const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
import type { FC } from 'react';
import styled from 'styled-components';
import { UserLevelDetails } from '../../../lib/enums/userLevels';
import type { CyberIqLevelBrackets } from '../../../apiHooks/useTeamSecuritySnapshotQuery';
import { NamedContentEntryText } from '../../ContentEntryText/NamedContentEntryText';

type LevelsBreakdownDetailsProps = {
  details: CyberIqLevelBrackets[];
};

export const LevelsBreakdownDetails: FC<LevelsBreakdownDetailsProps> = ({ details }) => {
  // Sort details by cyberIqLevel ascending
  const sortedDetails = [...details].sort(
    (a, b) => UserLevelDetails[a.cyberIqLevel].number - UserLevelDetails[b.cyberIqLevel].number
  );
  return (
    <LevelsBreakdownDetailsContainer>
      <HeaderTitle>
        <LevelsTitle>
          <NamedContentEntryText refKey="managerTeamSecuritySnapshot" subKey="levelsBreakdown" container="span" />
          {': '}
        </LevelsTitle>
        <TeamCountTitle>
          <NamedContentEntryText refKey="managerTeamSecuritySnapshot" subKey="teamMembers" container="span" />
        </TeamCountTitle>
      </HeaderTitle>
      <LevelDetailsContainer>
        {sortedDetails.map((detail: CyberIqLevelBrackets) => {
          const userLevelDetailsMap = UserLevelDetails[detail.cyberIqLevel];
          return (
            <LevelDetail key={detail.cyberIqLevel}>
              <LeftSection>
                <LevelChip background={userLevelDetailsMap.color}>{userLevelDetailsMap.level}</LevelChip>
                <span>{userLevelDetailsMap.name}</span>
              </LeftSection>
              <RightSection>
                <TeamMemberCount>{detail.learnerCount}</TeamMemberCount>
                <span>{detail.learnerPercentage}%</span>
              </RightSection>
            </LevelDetail>
          );
        })}
      </LevelDetailsContainer>
    </LevelsBreakdownDetailsContainer>
  );
};
const LevelsBreakdownDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: space-between;
  width: 400px;
  padding: 10px;
`;

const HeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-weight: 500;
`;

const LevelsTitle = styled.span`
  color: ${({ theme }) => theme.colors.strong};
`;

const TeamCountTitle = styled.span`
  color: ${({ theme }) => theme.colors.heading};
`;

const LevelDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const LevelDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px;
  font-weight: 500;
`;

const TeamMemberCount = styled.span`
  color: ${({ theme }) => theme.colors.strong};
`;

const RightSection = styled.div`
  display: flex;
  gap: 16px;
  min-width: 100px;
  justify-content: flex-end;
  align-items: center;

  > span,
  > ${TeamMemberCount} {
    display: inline-block;
    min-width: 40px;
    text-align: right;
  }
`;

const LevelChip = styled.div<{ background: string }>`
  display: flex;
  padding: 2px 4px;
  color: white;
  background-color: ${({ background }) => background};
  border-radius: 10px;
  width: 60px;
  align-items: center;
  justify-content: center;
  font-weight: 400;
`;
